import { Routes } from '@angular/router';
import { Dashboard } from './dashboard/dashboard';
import { SignUp } from './sign-up/sign-up';
import { HouseComponent } from './house/house';
import { TransactionComponent } from './transaction/transaction';
import { RenterComponent } from './renter/renter';
import { Activity } from './activity/activity';
import { SignInComponent } from './sign-in/sign-in';
import { User } from './user/user';
import { SubscriptionComponent } from './subscription/subscription';
import { roleAccessGuard } from './core/auth/role-access.guard';
import { HelpUserManualComponent } from './help-user-manual/help-user-manual';

export const routes: Routes = [
    { path: '', component:  SignInComponent},
    { path: 'dashboard', component:  Dashboard, canActivate: [roleAccessGuard]},
    { path: 'signIn', component: SignInComponent },
    { path: 'signUp', component: SignUp },
    { path: 'house', component: HouseComponent, canActivate: [roleAccessGuard] },
    { path: 'payment', component: TransactionComponent, canActivate: [roleAccessGuard] },
    { path: 'renter', component: RenterComponent, canActivate: [roleAccessGuard] },
    { path: 'other', component: User, canActivate: [roleAccessGuard] },
    { path: 'subscription', component: SubscriptionComponent, canActivate: [roleAccessGuard] },
    { path: 'help-user-manual', component: HelpUserManualComponent, canActivate: [roleAccessGuard] },
    { path: 'activity', component: Activity, canActivate: [roleAccessGuard] },
];
